 import { createClient } from "@nhost/nhost-js"; 
 export const nhost = createClient({ subdomain: 
    (import.meta.env.VITE_NHOST_SUBDOMAIN as string) || "necmxjmbpshfnlnbxlkp", region: 
    (import.meta.env.VITE_NHOST_REGION as string) || "eu-central-1", functionsUrl: "https://api.manayadatalink.com", });
